<template>
  <a-modal
    v-model="showModal"
    :centered="true"
    height="100%"
    class="mobile-modal-fullscreen"
    :footer="null"
    :closable="false"
    :bodyStyle="{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px', gap: '24px', position: 'relative' }"
    width="587px"
  >
    <div class="header">
      <span :style="{ marginRight: '24px' }" @click="handleback"><font-awesome-icon size="lg" class="xmark" :icon="['far', 'arrow-left']"/></span>
      <span class="title">Create Event</span>
      <div @click="handleCancel()" class="close-mob">
        <font-awesome-icon size="1x" class="xmark" :icon="['far', 'times']" />
      </div>
      <button
        @click="handleApply"
        class="apply-filter-btn-mob"
        :style="{ background: getPrimaryColor(), opacity: checkDisabled ? 0.5 : 1, cursor: checkDisabled ? 'auto !important' : 'pointer' }"
        :disabled="checkDisabled"
      >
        Done
      </button>
    </div>
    <div class="cont">
      <template v-if="addingImages">
        <div v-if="isImageUploading" class="d-flex justify-content-center mt-2 w-100">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">Loading image...</div>
        </div>
        <div class="w-100" v-else-if="!fileList.length && !isImageUploading">
          <!-- @click="handleImageUpload" -->
          <div class="add-symptoms">
            <div class="add-img-cont">
              <input
                class="camera-icon-inp position-absolute"
                type="file"
                accept="image/png, image/jpeg, image/gif, image/svg+xml"
                ref="fileInput"
                @change="handleImageUpload"
                :style="{ right: 0, cursor: 'pointer', width: '100%', height: '100%', opacity: '0' }"
              />
              <div class="plus-icon">
                <font-awesome-icon size="1x" class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'plus']" />
              </div>
              <span class="add-img-text" :style="{ color: getPrimaryColor() }"> Add Image </span>
              <span class="add-img-subtext hide-in-mobile">or drag and drop</span>
            </div>
          </div>
        </div>
        <div class="position-relative image-cont" v-else>
          <font-awesome-icon
            :icon="['far', 'times']"
            class="gray500 position-absolute bg-gray100 p-1 ar1 font20 rounded-circle cp"
            :style="{ top: '10px', right: '10px', 'z-index': 10, height: '24px', width: '24px' }"
            @click="handleCancelImage"
          />
          <img class="img" v-if="fileList.length" :src="fileList[0].url" />
        </div>
      </template>
      <div class="sub-cont">
        <span class="head">Event Type <span class="red300">*</span></span>
        <a-radio-group v-model="choice" name="radioGroup">
          <a-radio :value="'Online'">Online</a-radio>
          <a-radio :value="'In person'">In person</a-radio>
        </a-radio-group>
      </div>
      <div class="sub-cont">
        <span class="head">
          Event Name
          <span class="red300">*</span>
        </span>
        <a-input class="input" placeholder="Name" v-model="eventName" />
      </div>
      <div class="sub-cont">
        <span class="head">Timezone</span>
        <select class="select" v-model="timeZone">
          <!-- <option value="" disabled selected hidden>(UTC-05:00) Central Time (US and Canada)</option> -->
          <option value="UTC-05:00">(UTC-05:00) Central Time (US and Canada)</option>
          <option value="UTC-07:13">(UTC-07:13) Central Standard Time Chicago (GMT-6)</option>
          <option value="UTC-06:13">(UTC-06:13) Mountain Standard Time Denver (GMT-7)</option>
          <option value="UTC-06:13">(UTC-06:13) Mountain Standard Time Phoenix (GMT-7)</option>
          <option value="UTC-05:13">(UTC-05:13) Pacific Standard Time Los Angeles (GMT-8)</option>
          <option value="UTC-04:13">(UTC-04:13) Alaska Standard Time Anchorage (GMT-9)</option>
          <option value="UTC-03:13">(UTC-03:13) Hawaii-Aleutian Standard Time Honolulu (GMT-10)</option>
        </select>
      </div>
      <div class="sub-cont">
        <span class="head">Company</span>
        <a-input class="input" placeholder="Company Name" v-model="companyName" />
      </div>
      <div class="sub-sub-cont">
        <div>
          <span class="head">Start Date <span class="red300">*</span></span>
          <!-- <form class="nosubmitn" onSubmit="return false;">
            <input class="nosubmitn cp" type="date" v-model="startDate" :min="new Date().toISOString().split('T')[0]" onclick="this.showPicker()" />
          </form> -->
          <DatePicker
            v-model="startDate"
            type="date"
            class="w-100 new-datepicker"
            :append-to-body="false"
            :disabled-date="tempValue => (isDateToday(tempValue) ? false : tempValue < new Date())"
            placeholder="Select Date"
            :editable="false"
          />
        </div>
        <div>
          <span class="head">Start Time <span class="red300">*</span></span>
          <!-- <form class="nosubmitn" onSubmit="return false;">
            <input class="nosubmitn cp" type="time" v-model="startTime" onclick="this.showPicker()" />
          </form> -->
          <DatePicker
            v-model="startTime"
            type="time"
            class="new-datepicker w-100"
            :append-to-body="false"
            :disabled-time="tempValue => (!isDateToday(startDate) ? false : tempValue < new Date())"
            placeholder="Select Time"
            :use12h="true"
            :minute-step="15"
            :editable="false"
            :show-second="false"
            popup-class="event-time-picker"
            :format="'hh:mm A'"
            :disabled="!startDate"
          />
        </div>
      </div>
      <div class="sub-cont">
        <div class="check-cont">
          <input type="checkbox" class="checkbox" v-model="checkOne" />
          <span class="check-text">Add end date and time</span>
        </div>
      </div>
      <div v-if="checkOne" class="sub-sub-cont">
        <div>
          <span class="head">End Date</span>
          <!-- <form class="nosubmitn" onSubmit="return false;">
            <input class="nosubmitn cp" type="date" v-model="endDate" :min="new Date().toISOString().split('T')[0]" onclick="this.showPicker()" />
          </form> -->
          <DatePicker
            v-model="endDate"
            type="date"
            class="w-100 new-datepicker"
            :append-to-body="false"
            :disabled-date="tempValue => tempValue < new Date(startDate || '')"
            placeholder="Select Date"
            :editable="false"
            :disabled="!startTime"
          />
        </div>
        <div>
          <span class="head">End Time</span>
          <!-- <form class="nosubmitn" onSubmit="return false;">
            <input class="nosubmitn cp" type="time" v-model="endTime" onclick="this.showPicker()" />
          </form> -->
          <DatePicker
            v-model="endTime"
            type="time"
            class="new-datepicker w-100"
            :append-to-body="false"
            :disabled-time="tempValue => (new Date(startDate).getTime() === new Date(endDate).getTime() ? tempValue < new Date(startTime) : false)"
            placeholder="Select Time"
            :minute-step="15"
            :show-second="false"
            popup-class="event-time-picker"
            :editable="false"
            :use12h="true"
            :disabled="!endDate"
            :format="'hh:mm A'"
          />
        </div>
      </div>
      <div class="sub-cont">
        <span class="head">Link</span>
        <a-input class="input" placeholder="Enter a valid url" v-model="link" />
      </div>
      <div class="sub-cont">
        <span class="head">Description</span>
        <a-textarea :resize="none" class="text-area" placeholder="Description" v-model="texts" :maxlength="2500" />
        <span class="count-text">{{ texts.length }}/2500</span>
      </div>
      <div class="sub-cont">
        <span class="head">Speakers</span>
        <div class="d-flex align-items-center mb-4 w-100" v-for="(speaker, index) in speakers" :key="index">
          <input class="speaker w-100" placeholder="Enter speaker full name" v-model="speakers[index]" />
          <font-awesome-icon :icon="['fas', 'trash']" class="error300 cp ml-3" @click="handleDeleteSpeaker(index)" />
        </div>
        <p @click="handleAddSpeaker" class="cp font14 fw700 mb-0" :style="{ color: getPrimaryColor() }" v-if="speakers.length < 3">Add new speaker</p>
      </div>
      <div class="footer">
        <button
          @click="handleApply"
          class="apply-filter-btn"
          :style="{ background: getPrimaryColor(), opacity: checkDisabled ? 0.5 : 1, cursor: checkDisabled ? 'auto !important' : 'pointer' }"
          :disabled="checkDisabled"
        >
          Done
        </button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { faArrowLeft, faTimes } from "@fortawesome/pro-regular-svg-icons"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import s3Upload from "../../utilities/imageUploader"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"

const UserRepository = RepositoryFactory.get("user")
library.add(faArrowLeft, faTimes, faCheck)

export default {
  name: "createEvent",
  components: { DatePicker },
  props: { handleOtherModals: Function },
  data() {
    return {
      texts: "",
      showModal: false,
      isImageUploading: false,
      fileList: [],
      choice: "",
      link: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      eventName: "",
      companyName: "",
      timeZone: "UTC-05:00",
      addingImages: true,
      checkOne: false,
      data: {},
      editing: false,
      editingTags: [],
      editingId: 0,
      speakers: [""],
    }
  },
  watch: {
    startDate: {
      handler(v) {
        // console.log("startDate:", v)
        if (this.endDate && new Date(this.endDate) < new Date(v)) {
          this.endDate = v
          if (this.startTime > this.endTime) {
            this.endTime = this.startTime
          }
        }
      },
    },
    startTime: {
      handler(v) {
        // console.log("startTime:", v)
        if (this.endTime && new Date(this.endTime) < new Date(v) && new Date(this.startDate).getTime() === new Date(this.endDate).getTime()) {
          this.endTime = v
        }
      },
    },
    endDate: {
      handler(v) {
        // console.log("endDate:", v)
        if (new Date(this.startDate) > new Date(v)) {
          this.endDate = this.startDate
          this.$notification.error({ message: "Error", description: "Invalid End Date" })
        }
      },
    },
    endTime: {
      handler(v) {
        // if (!this.endDate) {
        //   this.$notification.error({ message: "Error", description: "Please select end DATE first" })
        //   this.endTime = ""
        //   return
        // }
        // console.log("this.startTime: ", this.startTime)
        // console.log({ v })
        // if (this.startDate === this.endDate && this.convertTime12to24(this.startTime) > this.convertTime12to24(v)) {
        //   this.endTime = this.startTime
        //   this.$notification.error({ message: "Error", description: "Invalid End Time" })
        // }
      },
    },
  },
  computed: {
    checkDisabled() {
      return !this.eventName || !this.startDate || !this.startTime || !this.choice
    },
  },
  methods: {
    convertTime12to24(time12h) {
      const [time, modifier] = time12h.split(" ")
      let [hours, minutes] = time.split(":")
      if (hours === "12") {
        hours = "00"
      }
      if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12
      }
      return `${hours}:${minutes}`
    },

    handleDeleteSpeaker(index) {
      if (this.speakers.length === 1) {
        this.$notification.error({ message: "Error", description: "Minimum one speaker is required" })
        return
      }
      this.speakers.splice(index, 1)
    },

    handleAddSpeaker(index) {
      if (this.speakers.length === 3) {
        this.$notification.error({ message: "Error", description: "Maximum three speakers allowed" })
        return
      }
      this.speakers.push("")
    },

    handleCancelImage() {
      this.fileList = []
    },

    handleApply() {
      // console.log("this.startDate:", this.startDate)
      // console.log("this.startTime:", this.startTime)
      // console.log("new Date(this.startTime).getUTCHours():", new Date(this.startTime).getUTCHours())
      // console.log("new Date(this.startTime).getUTCMinutes():", new Date(this.startTime).getUTCMinutes())
      // console.log("this.startTime.getUTCHours():", this.startTime.getUTCHours())
      // console.log("this.endDate:", this.endDate)
      // console.log("this.endTime:", this.endTime)
      // console.log("new Date(this.endTime).getUTCHours():", new Date(this.endTime).getUTCHours())
      // console.log("new Date(this.endTime).getUTCMinutes():", new Date(this.endTime).getUTCMinutes())
      // console.log("this.endTime.getUTCHours():", this.endTime.getUTCHours())

      // return

      if (!this.eventName || !this.startDate || !this.startTime || !this.choice) {
        this.$notification.error({ message: "Error", description: "You need to fill all the necessary fields correctly to create Event." })
      } else {
        this.handleOtherModals(
          "add",
          {
            eventName: this.eventName,
            link: this.link,
            des: this.texts,
            img: this.fileList,
            companyName: this.companyName,
            timeZone: this.timeZone,
            startTime: `${new Date(this.startTime)
              .getHours()
              .toString()
              .padStart(2, 0)}:${new Date(this.startTime)
              .getMinutes()
              .toString()
              .padStart(2, 0)}`,
            // startTime: this.startTime,
            // startDate: this.startDate,
            startDate: this.moment(new Date(this.startDate).toDateString()).format("YYYY-MM-DD"),
            // endDate: this.endDate,
            endDate: this.endDate ? this.moment(new Date(this.endDate).toDateString()).format("YYYY-MM-DD") : null,
            endTime: this.endTime
              ? `${new Date(this.endTime)
                  .getHours()
                  .toString()
                  .padStart(2, 0)}:${new Date(this.endTime)
                  .getMinutes()
                  .toString()
                  .padStart(2, 0)}`
              : null,
            // endTime: this.endTime,
            eventType: this.choice,
            speaker: this.speakers.filter(speaker => speaker),
          },
          "event",
          this.editing,
          this.editingTags,
          this.editingId
        )
        this.handleCancel()
      }
    },

    handleback() {
      this.handleCancel()
      this.handleOtherModals("back")
    },

    async handleImageUpload() {
      if (this.fileList.length) {
        this.$notification.error({ message: "Error", description: "Cannot add more than one image" })
      } else {
        const file = this.$refs.fileInput.files[0]
        this.isImageUploading = true
        try {
          if (file.size / (1024 * 1024) > 5) {
            this.$notification.error({ message: "Error", description: "File size exceeds 5MB limit" })
            const input = this.$refs.file
            input.type = "text"
            input.type = "file"
          } else if (!file.type.includes("image")) {
            this.$notification.error({ message: "Error", description: "Please select only image" })
          } else {
            const urlPayload = { file_name: [file.name] }
            const urlData = await UserRepository.getPresignedUrl(urlPayload)
            const fileName = urlData.data.data.filename[0]
            await s3Upload(urlData.data.data.url[0], file)
            // this.post_attach.push(fileName)
            const fileListData = { name: fileName, status: "done", url: urlData.data.data.preview_url }
            this.fileList.push(fileListData)
          }
        } catch (err) {}
        this.isImageUploading = false
      }
    },

    onCheckAllChange(e) {
      this.answerArray = e.target.checked ? this.filterOptions : []
      this.indeterminate = false
    },

    show(data, edit = false, tags = [], id = 0) {
      this.editing = edit
      this.editingTags = tags
      this.editingId = id
      // console.log('Event editing ->',this.editing);
      this.showModal = true
      if (data) {
        this.texts = data.des ? data.des : ""
        this.link = data.link ? data.link : ""
        this.fileList = data.img ? data.img : []
        this.endDate = data.endDate ? data.endDate : ""
        this.endTime = data.endTime ? data.endTime : ""
        this.startDate = data.startDate ? data.startDate : ""
        this.startTime = data.startTime ? data.startTime : ""
        this.eventName = data.eventName ? data.eventName : ""
        this.companyName = data.companyName ? data.companyName : ""
        this.timeZone = data.timeZone ? data.timeZone : "UTC-05:00"
      } else {
        this.texts = ""
        this.fileList = []
        this.choice = ""
        this.link = ""
        this.startDate = ""
        this.endDate = ""
        this.startTime = ""
        this.endTime = ""
        this.eventName = ""
        this.companyName = ""
        this.timeZone = "UTC-05:00"
        this.speakers = [""]
      }
    },

    handleCancel() {
      // console.log("Modal Canceled")
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.check-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}
.checkbox {
  height: 18px;
  width: 18px;
  cursor: pointer;
}
.check-cont {
  display: flex;
  gap: 8px;
}
.sub-sub-cont {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    flex-direction: column;
  }
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: url(../../assets/images/calendar-grey.png) no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  background: url(../../assets/images/clock.png) no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.select {
  font-size: 16px;
  line-height: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: url("../../assets/images/dropdown-arrow.png") no-repeat right;
  -webkit-appearance: none;
  appearance: none;
  background-position-x: 95%;
  outline: none;
  cursor: pointer;
  color: #0f1734;
  @media screen and (max-width: 700px) {
    font-size: 14px !important;
  }
}

.btn-end {
  display: flex;
  align-items: flex-end;
}

input[type="search"]::placeholder {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  // color: #94A3B8;
}

input:focus {
  // border: none;
  outline: none;
}

.close-icon {
  position: relative;
  left: -22px;
  top: -39px;
  cursor: pointer;
}
form.nosubmit {
  width: 100%;
  border: none;
  padding: 0;
}

input:active {
  // border: none;
  outline: none;
}
input.nosubmit {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 4px 4px 4px 48px;
  gap: 8px;
  font-size: 16px;
  line-height: 32px;
  font-weight: 700;
  width: 100%;
  height: 56px;
  background-image: url("../../assets/images/search-grey.png");
  background-repeat: no-repeat;
  background-position: 18px;
}

input.nosubmitn {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 257.5px;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.count-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  text-transform: capitalize;
  color: #94a3b8;
  width: 100%;
  justify-content: flex-end;
  margin-top: 4px;
}

.text-area {
  min-height: 151px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
  resize: none;
}

.input {
  // width: 539px;
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
}

textarea::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}
.input[type="time"]::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}
.input[type="date"]::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

.input::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

.sub-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  // min-width: 539px;
  width: 100%;
  // min-height: 92px;
}
.head {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}

.add-symptoms {
  width: 100%;
  // min-width: 539px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  min-height: 94px;
  background: rgba(37, 103, 237, 0.05);
  border: 1px dashed #94a3b8;
  // background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
  // background-position: right;
  background-size: 1px 16px;
  background-repeat: repeat-y;
  position: relative;
  cursor: pointer;
  @media screen and (max-width: 700px) {
    min-height: 171px;
    border: 1.5px dashed #94a3b8;
  }
  .border-top,
  .border-bottom {
    position: absolute;
    border: none;
    left: 7px;
    margin: 0;
  }
  .border-top {
    top: -25px;
    &::after {
      content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
      letter-spacing: 4px;
      height: 0;
      overflow: hidden;
      color: #94a3b8;
    }
  }
  .border-left {
    position: absolute;
    // background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
    /* background-position: left; */
    background-size: 1px 17px;
    background-repeat: repeat-y;
    height: 55px;
    width: 10px;
    left: 0;
  }
  .border-bottom {
    bottom: -30px;
    &::after {
      content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
      letter-spacing: 4px;
      height: 0;
      overflow: hidden;
      color: #94a3b8;
    }
  }
  .addsymtoms-text {
    font-family: "Lato";
    font-weight: 700;
    color: #2a71d4;
  }
  // .plus-icon{
  //   // font-size: 30px;
  // }
  .addsymtoms-text {
    font-size: 14px;
    margin: 0 8px;
  }

  @media screen and (max-width: 900px) {
    height: 56px;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.img {
  width: 100%;
}
.image-cont {
  width: 100%;
  // height: 278px;
}
.add-img-subtext {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #647490;
}
.add-img-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.add-img-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;
}
.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
  gap: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}
.image-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 24px;
}

.image {
  width: 539px;
  height: 132px;
  border-radius: 8px;
  background-color: violet;
  background-blend-mode: screen multiply;
}

.image:hover {
  background: #2a71d4;
  opacity: 0.5;
}

.avatar:hover {
  background: #2a71d4;
  opacity: 0.5;
}

.apply-filter-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 82px;
  height: 48px;
  border-radius: 6px;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 91px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #47556e;
  border: none;
  cursor: pointer;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 100%;
  height: 48px;
  // margin-top: 104px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.category-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #33415f;
}

.grid-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 20px;
}
.condition-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 727px;
  overflow-y: scroll;
}

.condition-container::-webkit-scrollbar {
  width: 0 !important;
}
// .close{
// display: flex;
// flex-direction: column;
// justify-content: center;
// align-items: flex-end;
// padding: 0px;
// width: 480px;
// height: 24px;
// }

.apply-filter-btn-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    width: 82px;
    height: 48px;
    border-radius: 6px;
    text-transform: capitalize;
    color: #ffffff;
    border: none;
    cursor: pointer;
  }
}

.close-mob {
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.xmark {
  // width:12.5px;
  height: 20px;
  cursor: pointer;
  color: #94a3b8;
}
.title {
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
  @media screen and (max-width: 700px) {
    font-size: 20px !important;
  }
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: 29px;
}

.modalContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  position: relative;
  width: 587px;
  height: 529px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.ant-modal-content {
  border-radius: 8px;
}

.fw700 {
  font-weight: 700;
}

.mainHeading {
  font-size: 24px;
  line-height: 32px;
  color: #33415f !important;
}

.subHeading {
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  margin-top: 45px;
}

.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
}

.speaker {
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  height: 56px;
  font-size: 16px;
  line-height: 32px;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/createEvent.vue